import User from '@/datatypes/user';
import Enterprise from '@/datatypes/enterprise';
import Recipient from '@/datatypes/recipient';

export default class Document {
  public id: string;
  public title: string;
  public user: User;
  public userId: string;
  public enterprise: Enterprise;
  public enterpriseId: string;
  public message: string;
  public status: string;
  public sender: string;
  public created: string;
  public sent: string;
  public complete: string;
  public voidDate: string;
  public voidReason: string;
  public pageCount: string;
  public recipients: Array<Recipient> = new Array<Recipient>();

  constructor(options) {
    this.id = options.id;
    this.title = options.title;
    this.user = options.user;
    this.userId = options.userId;
    this.enterpriseId = options.enterpriseId;
    this.enterprise = options.enterprise;
    this.message = options.message;
    this.status = options.status;
    this.sender = options.sender;
    this.created = options.created;
    this.sent = options.sent;
    this.complete = options.complete;
    this.voidDate = options.voidDate;
    this.voidReason = options.voidReason;
    this.pageCount = options.pageCount;
    if (options.recipients) {
      this.recipients = options.recipients.map((recipient) => new Recipient(recipient));
    }
  }
}
